// Salvar arquivo perguntando ONDE salvar (File System Access API).
//
// Por que existe: o download clássico (<a download>) joga tudo direto na pasta
// Downloads, sem escolha. O usuário quer organizar as exportações de telemetria
// em pastas diferentes, então usamos showSaveFilePicker() quando disponível
// (Chrome/Edge em contexto seguro) e caímos no download clássico no resto
// (Firefox/Safari), que continuam funcionando como antes.
//
// Detalhe importante: showSaveFilePicker() exige "transient user activation"
// (~5s após o clique). Para conteúdo que demora a ser gerado (ex.: PDF via
// html2canvas), peça o destino ANTES de gerar — veja requestSaveHandle().

/** O navegador suporta escolher a pasta de destino? */
export const supportsFilePicker = () =>
    typeof window !== 'undefined' && typeof window.showSaveFilePicker === 'function';

/** Usuário fechou/cancelou o seletor de arquivos. */
export const isAbortError = (e) => e && (e.name === 'AbortError' || e.code === 20);

const pickerOptions = (suggestedName, { description, mime, ext }) => ({
    suggestedName,
    types:
        mime && ext
            ? [{ description: description || 'Arquivo', accept: { [mime]: [`.${ext}`] } }]
            : undefined,
});

/**
 * Abre o seletor de destino e devolve o handle (ou null se o navegador não
 * suportar). Lança AbortError se o usuário cancelar.
 * Use quando o conteúdo ainda vai ser gerado (mantém a ativação do clique).
 */
export async function requestSaveHandle(suggestedName, opts = {}) {
    if (!supportsFilePicker()) return null;
    return window.showSaveFilePicker(pickerOptions(suggestedName, opts));
}

/** Grava o blob num handle obtido por requestSaveHandle(). */
export async function writeBlobToHandle(handle, blob) {
    const writable = await handle.createWritable();
    await writable.write(blob);
    await writable.close();
}

/** Download clássico (fallback): vai direto para a pasta de downloads. */
export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

/**
 * Salva um blob JÁ PRONTO perguntando onde salvar; se o navegador não suportar,
 * faz o download clássico.
 * Retorna { saved, canceled, viaPicker }.
 */
export async function saveBlobAs(blob, filename, opts = {}) {
    if (supportsFilePicker()) {
        try {
            const handle = await requestSaveHandle(filename, opts);
            await writeBlobToHandle(handle, blob);
            return { saved: true, canceled: false, viaPicker: true };
        } catch (e) {
            // Cancelou: respeita a decisão — NÃO baixa escondido na pasta padrão.
            if (isAbortError(e)) return { saved: false, canceled: true, viaPicker: true };
            // Falha real do picker (ex.: contexto não seguro) → fallback.
        }
    }
    downloadBlob(blob, filename);
    return { saved: true, canceled: false, viaPicker: false };
}
